module.exports = __webpack_public_path__ + "media/newstyle/images/wordpress-8a3809244be9113f08760bfecdc0e309.svg";